import {Endpoint} from '@eryxcoop/appyx-comm';

export default class UpdateUserEndpoint extends Endpoint {

  adaptValues({userEmail, permissions, customersGroups}) {
    return {
          'email': userEmail,
          'customer_groups': this._adaptCustomerGroups(customersGroups),
          'permissions': this._adaptPermissions(permissions)
        }
  }

  _adaptPermissions(permissions) {
    if (permissions === null){
        return []
    }
    return permissions
  }


  _adaptCustomerGroups(customersGroups) {
      return customersGroups.map(customerGroup => {
          return {
              'name': customerGroup.name,
              'code': customerGroup.code,
              'customers': customerGroup.customers
          }
      }
      );
  }

}